import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/free-mode";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import clsx from "clsx";
import LazyImage from "../components/v4/LazyLoadImage/LazyImage";
import { useInView } from "react-intersection-observer";

import transformImg1 from "../images/v4/whatsappPage/images/transformImg1.png";
import transformImg2 from "../images/v4/whatsappPage/images/transformImg2.png";
import transformImg3 from "../images/v4/whatsappPage/images/transformImg3.png";
import transformImg4 from "../images/v4/whatsappPage/images/transformImg4.png";

import supportImg1 from "../images/v4/whatsappPage/images/supportImg1.png";
import supportImg2 from "../images/v4/whatsappPage/images/supportImg2.png";
import supportImg3 from "../images/v4/whatsappPage/images/supportImg3.png";

import heroBgImage from "../images/v4/whatsappPage/images/heroBgImage.png";

import wpAdPageBanner from "../images/v4/whatsappPage/images/wpAdPageBanner.webp";
import wpAdPageBannerMobile from "../images/v4/whatsappPage/images/wpAdPageBannerMobile.webp";

import adLandingpageBackground1 from "../images/v4/whatsappPage/images/adLandingpageBackground1.png";

import whiteCheckCircle from "../images/v4/whatsappPage/icons/whiteCheckCircle.svg";

import partnerIcon1 from "../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../images/v4/aiPage/icons/partnerIcon8.png";
import FaqSection from "../components/v4/FaqSection/FaqSection";

import companyLogo from "../images/v4/logos/companyLogo.svg";

import trustedIcon from "../images/v4/logos/trustedIcon.svg";
import trustedIcon1 from "../images/v4/logos/trustedIcon1.png";
import trustedIcon2 from "../images/v4/logos/trustedIcon2.png";
import trustedIcon3 from "../images/v4/logos/trustedIcon3.png";
import trustedIcon4 from "../images/v4/logos/trustedIcon4.png";
import trustedIcon5 from "../images/v4/logos/trustedIcon5.png";

import experienceImg1 from "../images/v4/whatsappPage/images/experienceImg1.png";
import experienceImg2 from "../images/v4/whatsappPage/images/experienceImg2.png";
import experienceImg3 from "../images/v4/whatsappPage/images/experienceImg3.png";
import experienceImg4 from "../images/v4/whatsappPage/images/experienceImg4.png";

import moreFeaturesBg from "../images/v4/whatsappPage/images/moreFeaturesBg.png";

import instantChatBg1 from "../images/v4/linkGeneration/images/instantChatBg1.png";
import instantChatBg2 from "../images/v4/linkGeneration/images/instantChatBg2.png";
import instantChatBg3 from "../images/v4/linkGeneration/images/instantChatBg3.png";
import instantChatIcon1 from "../images/v4/whatsappPage/icons/instantChatIcon1.svg";
import instantChatIcon2 from "../images/v4/whatsappPage/icons/instantChatIcon2.svg";
import instantChatIcon3 from "../images/v4/whatsappPage/icons/instantChatIcon3.svg";

import wpLandingAdPageBg from "../images/v4/whatsappPage/images/wpLandingAdPageBg.png";
import wpLandingAdPageBgNew from "../images/v4/whatsappPage/images/wpLandingAdPageBgNew.png";
import wpLandingAdPageBgNewMobile from "../images/v4/whatsappPage/images/wpLandingAdPageBgNewMobile.png";

import greenCheckIcon from "../images/v3/icons/GreenCheckIcon.webp";

import { Collapse, Divider, makeStyles } from "@material-ui/core";

import Link from "../components/v2/Link";
import downArrow from "../images/v4/aiPage/icons/downArrow.svg";

import wpBannerImg from "../images/v4/whatsappPage/images/wpBannerImg.png";
import bannerBgImg2 from "../images/v4/whatsappPage/images/bannerBgImg2.png";
import bannerImgNew from "../images/v4/whatsappPage/images/bannerImgNew.png";

import whatsappBusinessPartner from "../images/v3/singaporeCrmHomepage/whatsappBusinessPartner.png";
import metaBusinessPartner from "../images/v3/singaporeCrmHomepage/metaBusinessPartner.png";
import trailBlazerBusinessPartner from "../images/v3/singaporeCrmHomepage/trailBlazerBusinessPartner.png";

import wpAdPageAnimation from "../animations/wpAdPageAnimation.json";
import wpAdPageAnimationMobile from "../animations/wpAdPageAnimationMobile.json";
import LottieIcon from "../components/v4/LottieIcon";
import whatsAppFeatureIcon from "../images/v4/homepage/icons/whatsAppFearureIcon.svg";
import SEO from "../components/SEO";
import TruestedSection from "../components/v4/TrustedSection/TruestedSection";

import callImg from "../images/v2/campaigns/callNew.svg";
import IMDALockup from "../components/v4/IMDALockup/IMDALockup";

export const conversionEventOnCall = () => {
  if (typeof window.gtag === "function")
    window.gtag("event", "conversion", {
      send_to: "AW-615460128/prVoCM7gjuwBEKDavKUC",
    });
};

const useStyles = makeStyles((theme) => ({
  broadcastContainer: {
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
    imdaStyle:{
    [theme.breakpoints.down("md")]: {
      padding: "0px 16px",
      },
  },
  broadcastBox: {
    display: "flex !important",
    padding: "32px",
    background: "#009249",
    alignItems: "flex-start",
    borderRadius: "20px",
    justifyContent: "flex-start",
    minWidth: "85%",
    maxWidth: "85%",
    transition: "0.3s ease",
    "&.active": {
      transform: "scale(1) !important",
    },
    "&.inActive": {
      transform: "scale(0.8) !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      gap: "24px",
      flexDirection: "column",
      minHeight: "700px",
    },
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
    },
  },
  broadcastContainerInner: {
    width: "100%",
    padding: "0 4rem 4rem !important",
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px 40px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "0 19rem 6rem !important",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "max-content !important",
      "& img": {
        width: "100px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 80px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  pointerImg: {
    "& img": {
      width: "28px",
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        width: "10px",
      },
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  aIPowered: {
    background: `url(${adLandingpageBackground1})`,
    backgroundSize: "cover",
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    borderRadius: "24px",
    "& .centerContainer": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      borderRadius: "16px",
    },
  },
  statsContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "60px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
    },
  },
  statsBox: {
    width: "24%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
    background: "#0020205e",
    borderRadius: "30px",
    padding: "20px",
    minHeight: "320px",
    backdropFilter: "blur(30px)",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      minHeight: "auto",
    },
    "& .border": {
      border: "1px solid #fefefe1c",
    },
  },
  statsBoxBody: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "5px",
    "& p": {
      color: "#B6DDFF",
    },
    "& p:last-child": {
      color: "#9DBACF",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& ul": {
        paddingLeft: "0",
      },
      "& li": {
        marginBottom: "10px",
      },
    },
  },
  statsFont: {
    fontSize: "80px",
    color: "#B6DDFF",
    display: "flex",
    alignItems: "baseline",
    "@media only screen and (max-width: 600px)": {
      fontSize: "60px",
    },
  },
  supportSystem: {
    background: "#1D0240",
    borderRadius: "24px",
    paddingBottom: "200px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      borderRadius: "16px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "80%",
    marginTop: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
      marginTop: "0px",
      overflow: "auto",
      gap: "15px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  supportBox: {
    top: "412px",
    width: "100%",
    display: "flex",
    padding: "40px",
    position: "absolute",
    background: "#5e278ae0",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-evenly",
    "& $broadcastLeftContainer": {
      width: "45%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },

    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      top: "280px",
    },
    "@media only screen and (max-width: 350px)": {
      top: "320px",
    },
  },
  smeSection: {
    background: "#FAF2FF",
    paddingTop: "370px",
    "& .container": {
      padding: "0",
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      marginTop: "120px",
      "@media only screen and (max-width: 600px)": {
        marginTop: "60px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
    },
    "@media only screen and (max-width: 600px) and (min-width: 400px)": {
      paddingTop: "620px",
    },
  },
  smeImage: {
    // background: "white",
    width: "100%",
    cursor: "pointer",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  smeSectionInner: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    "& p": {
      width: "70%",
      textAlign: "center",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(89deg, #015352 0%, #00926A 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  headerContainer: {
    width: "100%",
    margin: "auto",
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    zIndex: "100",
    transition: "0.5s ease",
  },
  headerContainerInner: {
    position: "relative",
    width: "100%",
    padding: "10px 32px",
    maxWidth: "1200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "rgb(7 34 53 / 90%)",
    backdropFilter: "blur(10px)",
    borderRadius: "0px 0px 16px 16px",
    transition: "0.3s ease",
    "&.glassEffect": {
      background: "rgb(7 34 53 / 70%)",
      backdropFilter: "blur(7px) contrast(1)",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    "&.darkBackground": {
      background: "rgb(7 34 53 / 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "10px 15px",
    },
    // Same widths as the main navbar (TopAppBar headerContainerInner)
    "@media only screen and (min-width: 1900px)": {
      maxWidth: "1280px",
    },
  },
  rightNavigation: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "20px",
    "& a": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "5px",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none",
        color: "white",
      },
    },
    "& .primaryButton": {
      zIndex: "2",
      "@media only screen and (max-width: 600px)": {
        padding: "10px 15px",
        fontSize: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "5px",
      "& p:first-child": {
        display: "none",
      },
    },
  },
  pageFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",

    background: "linear-gradient(90deg, #011D32 0%, #00182B 100%)",
    "& p": {
      color: "#9097A6",
      "@media only screen and (max-width: 600px)": {
        fontSize: "12px",
      },
    },
    "& a": {
      color: "#9097A6",
      "@media only screen and (max-width: 600px)": {
        fontSize: "12px",
      },
    },
    "& .container": {
      padding: "30px 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "@media only screen and (max-width: 600px)": {
        gap: "10px",
        padding: "15px",
        alignItems: "flex-start",
        flexDirection: "row",
        justifyContent: "center",
        flexWrap: "wrap",
      },
    },
  },
  whatsappSectionContainer: {
    backgroundImage: `url(${wpLandingAdPageBgNew})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "70px 0 0 0",
    "& .container": {
      paddingBottom: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      backgroundImage: `url(${wpLandingAdPageBgNewMobile})`,
      padding: "64px 0 0 0",
      "& .container": {
        paddingBottom: "15px",
      },
    },
  },
  whatsappContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "25px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "32px",
    },
  },
  whatsappContainerLeft: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "51%",
    gap: "16px",
    flexDirection: "column",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #084FFF 0%, #00BFA5 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
    },
  },
  whatsappContainerRight: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  formContainer: {
    width: "100%",
    background: "#fff",
    boxShadow: "0px 0px 21px #00000029",
    borderRadius: "0 0 20px 20px",
    padding: "0px",
    height: "100%",
    minHeight: "470px",
    "@media only screen and (max-width: 600px)": {
      height: "470px",
      padding: "0",
    },

    overflow: "visible",
  },
  tagsContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    width: "80%",
    gap: "12px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tag: {
    padding: "10px",
    borderRadius: "20px",
    background: "#CBF0EA5C",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
  },
  formHeader: {
    textAlign: "center",
    padding: "20px",
    background: "linear-gradient(90deg, #0C408D 0%, #028161 100%)",
    borderRadius: "20px 20px 0 0",
    boxShadow: "0px 0px 21px #00000029",
    "& span": {
      color: "#5CFFB2",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "12px",
    },
  },
  experienceContainer: {
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "40px",
  },
  experienceContainerLeft: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "30px",
    },
  },
  faqBox: {
    borderBottom: "1px solid #C4E4DC",
    paddingBottom: "14px",
    position: "relative",
    transition: "0.3s ease",
    "&::after": {
      left: "0",
      bottom: "-2px",
      width: "0",
      height: "3px",
      content: '""',
      position: "absolute",
      transition: "0.3s ease",
      borderRadius: "10px",
      background:
        "linear-gradient(90deg, #25D366 0%, #08B57B 66%, #72E9B2 100%)",
    },
    "&.active::after": {
      transition: "5.5s ease",
      width: "100%",
    },
  },
  faqHeader: {
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  experienceContainerRight: {
    width: "40%",
    minHeight: "450px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      display: "none",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 0 ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
  },
  leftNavigation: {
    "@media only screen and (max-width: 600px)": {
      "& img": {
        width: "150px",
      },
    },
  },
  wpFaq: {
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  rewards: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "10px",
    boxShadow: "0px 0px 6px #00000029",
    padding: "15px 20px",
    borderRadius: "100px",
    width: "80%",
    marginTop: "10px",
    background: "#fff",
    "& .border": {
      borderRight: "1px solid #DBDBDB",
      width: "0",
    },
    "& img": {
      minWidth: "30%",
      "@media only screen and (max-width: 600px)": {
        minWidth: "26%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      justifyContent: "space-between",
      padding: "10px",
    },
  },
  bannerSection: {
    "& .centerContainer": {
      textAlign: "center",
      margin: "0 auto",
      width: "70%",
      "& img": {
        width: "56px",
        position: "relative",
        top: "10px",
        "@media only screen and (max-width: 600px)": {
          width: "24px",
          top: "3px",
        },
      },
      "@media only screen and (max-width: 600px)": {
        "& h2": {
          fontSize: "28px",
        },
        width: "80%",
        margin: "auto",
      },
    },
    "& .container": {
      padding: "130px 0",
      "@media only screen and (max-width: 600px)": {
        padding: "4.5rem 15px",
      },
    },
    width: "100%",
    "@media only screen and (min-width: 1900px)": {
      "& .container": {
        padding: "190px 0",
      },
    },
    // backgroundColor: "#00926A",
    // backgroundImage: `url(${bannerBgImg2})`,
    // backgroundSize: "cover",
    // backgroundRepeat: "repeat-x",
    // backgroundPosition: "center",
    // WebkitAnimation: "slidein 80s",
    // animation: "slidein 10s",
    // WebkitAnimationFillMode: "forwards",
    // animationFillMode: "forwards",
    // WebkitAnimationIterationCount: "infinite",
    // animationIterationCount: "infinite",
    // WebkitAnimationDirection: "alternate",
    // animationDirection: "alternate",
    // backgroundSpacing: "10px", // Add spacing between repeated background images
  },
  trustedSection: {
    marginTop: "0px",
  },
  backgroundAnimation: {
    position: "absolute",
    width: "100%",
    display: "block",
    "@media only screen and (max-width: 600px)": {
      display: "none",
    },
  },
  backgroundAnimationMobile: {
    display: "none",
    position: "absolute",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      display: "block",
    },
  },
  belowText: {
    width: "100%",
    textAlign: "right",
    color: "#6691b7",
    marginTop: "10px",
  },
  bannerImgSection: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    "& img": {
      width: "80%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  mobImg: {
    display: "none",
    "@media only screen and (max-width: 600px)": {
      display: "block",
    },
  },
  webImg: {
    display: "block",
    "@media only screen and (max-width: 600px)": {
      display: "none",
    },
  },
  moreFeatures: {
    backgroundImage: `url(${moreFeaturesBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& .header": {
      display: "flex",
      width: "50%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .body": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "stretch",
      width: "100%",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      "& .body": {
        flexDirection: "column",
        flexWrap: "wrap",
        rowGap: "15px",
      },
    },
    "@media only screen and (min-width: 1900px)": {
      "& .container": {
        paddingTop: "20px",
      },
    },
  },
  featureContainer: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "32%",
    gap: "22px",
    boxShadow: "0px 0px 16px #C1D7DB66",
    borderRadius: "16px",
    background: "#fff",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
    "& p": {
      width: "90%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& p": {
        width: "100%",
      },
    },
  },
}));

const WpAdLandingPage = () => {
  const classes = useStyles();

  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];

  const broadcastList = [
    {
      heading: "Resolve issues faster with Support CRM",
      points: [
        "Auto-create and assign tickets from WhatsApp chats.",
        "Escalate tickets that breach SLAs to avoid delays.",
        "Monitor response and resolution times with dashboards.",
        "Provide multi-agent access from a single WhatsApp number.",
        "Analyse customer sentiments with ease.",
      ],
      img: transformImg4, // Assuming transformImg4 exists or will be added
      alt: "Support CRM for faster issue resolution",
      background: "linear-gradient(180deg, #148966 0%, #063F2E 100%)", // New gradient for this item
    },
    {
      heading: "Turn leads into revenue with Sales CRM",
      points: [
        "Instantly capture and qualify leads 24/7.",
        "Customise sales pipelines to fit your business requirements.",
        "Forecast sales with pinpoint accuracy at every stage.",
        "Track sales performance and team productivity with visual dashboards.",
        "Automate lead assignments, task reminders, follow-ups, etc.",
      ],
      img: transformImg3,
      alt: "Best sales CRM",
      background: "linear-gradient(180deg, #B74AF5 0%, #5E02A8 100%)",
    },
    {
      heading: "Automate growth with WhatsApp CRM",
      points: [
        "Run WhatsApp marketing campaigns in seconds via broadcasts.",
        "Automate lead capture, bookings, and more with WhatsApp forms.",
        "Auto-respond with media-rich message templates and interactive buttons.",
        "Promote and sell instantly with product catalogs.",
        "Track response time, resolution time, etc. with message dashboard.",
      ],
      img: transformImg1,
      alt: "WhatsApp CRM for sales and marketing",
      background: "linear-gradient(180deg, #F77F4C 0%, #9227E9 100%)",
    },
    {
      heading: "Sell smarter with AI CRM capabilities",
      points: [
        "Create records, tasks, and follow-ups with one-click task management.",
        "Summarise conversations using natural language processing (NLP).",
        "Respond to queries during off-business hours with AssistAI chatbot.",
        "Reply to customers within seconds using generative AI.",
        "Create comprehensive lead profiles with data mining capabilities.",
      ],
      img: transformImg2,
      alt: "AI-powered WhatsApp CRM",
      background: "linear-gradient(180deg, #00B181 0%, #1448C4 100%)",
    },
  ];
  const supportList = [
    {
      heading: "Best CRM for beauty salons",
      desc: "Beauty salons use AI-powered CRM with WhatsApp integration to boost appointment bookings and enhance client satisfaction.",
      point: [
        "Promote offers and upsell services through WhatsApp broadcasts.",
        "Drive more bookings with targeted campaigns and catalog promotions.",
        "Handle complaints or reschedules instantly on WhatsApp.",
        "Collect reviews after service to build reputation and improve quality.",
      ],
      img: supportImg1,
      alt: "WhatsApp CRM for beauty salons",
    },
    {
      heading: "Smart CRM for food delivery services",
      desc: "Food delivery services can use WhatsApp AI CRM to streamline operations and deliver faster, personalised service.",
      point: [
        "Auto-send order confirmations, delivery updates, and tracking links.",
        "Respond automatically to customer queries with AI chatbot.",
        "Upsell add-ons (drinks, desserts) during order conversations.",
        "Handle complaints, late deliveries, or refunds quickly with ticketing.",
      ],
      img: supportImg2,
      alt: "WhatsApp CRM for food delivery services",
    },
    {
      heading: "All-in-one CRM for travel agencies",
      desc: "Travel agencies deliver personalised, efficient, and real-time customer engagement with AI-powered WhatsApp CRM.",
      point: [
        "Send personalised tour recommendations based on customer preferences.",
        "Collect customer documents via WhatsApp and streamline ticket bookings.",
        "Share travel itineraries and blast promotional campaigns via WhatsApp.",
        "Handle booking changes, cancellations, etc. with ticketing and escalation.",
      ],
      img: supportImg3,
      alt: "WhatsApp CRM for travel agencies",
    },
  ];
  const statsBoxContent = [
    {
      heading: "Faster response times",
      number: "70",
      content: 
      "Improve response efficiency by significantly reducing delays.",
      color: "#FFDFD2",
    },
    {
      heading: "Boost in sales revenue",
      number: "57",
      content:
        "Enhance sales performance and drive revenue growth with intelligent customer interaction.",
      color: "#F1DFFF",
    },
    {
      heading: "Reduction in operational cost",
      number: "30",
      content:
        "Streamline operations to save costs with automation and efficiency.",
      color: "#CEE9FF",
    },
    {
      heading: "Increase in conversion rates",
      number: "20",
      content:
        "Drive better customer engagement to effectively improve conversion rates.",
      color: "#BEE7E7",
    },
  ];
  const featureList = [
    {
      icon: instantChatIcon1,
      background: instantChatBg2,
      heading: "Sales teams",
      text: "Qualify prospects, automate follow-ups, and boost conversions.",
    },
    {
      icon: instantChatIcon2,
      background: instantChatBg1,
      heading: "Support teams",
      text: "Auto-assign tickets, escalate issues, and improve CSAT.",
    },
    {
      icon: instantChatIcon3,
      background: instantChatBg3,
      heading: "Business owners",
      text: "Gain visibility, cut inefficiencies, and grow sustainably.",
    },
  ];
  const faqs = [
    {
      question: "I’m an SME. How can WhatsApp CRM benefit us?",
      answer:
        "WhatsApp CRM system can be an effective sales tool for SMEs. With WhatsApp CRM, you can provide personalised customer service, streamline your sales process, and track all customer interactions in one place. With features such as message templates, automated replies, chatbots, tags, etc., you can save time and focus on growing your business.",
    },
    {
      question: "How does AI help in sales?",
      answer:
        "AI in sales leverages artificial intelligence to optimise sales processes. With Pepper Cloud CRM generative AI - AssistAI, you can automate chatflows using AI chatbot, manage routine tasks (such as capturing leads, answering common queries, etc.) without any manual intervention, analyse customer data, personalise communication, and boost overall sales effectiveness.",
    },
    {
      question: "How does AI help in customer support?",
      answer:
        "AI chatbots handle FAQs, auto-respond after hours, and suggest replies for agents. This reduces response time, cuts repetitive tasks, and ensures consistent service quality.",
    },
    {
      question: "How can WhatsApp CRM improve my customer support?",
      answer:
        "WhatsApp CRM centralises all customer conversations in one place. It enables multi-agent access, automated ticket creation, SLA tracking, and AI-powered responses — so your team resolves issues faster and improves satisfaction.",
    },
    {
      question: "Can I use my existing number for WhatsApp CRM integration?",
      answer:
        "Yes, you can use your existing number for WhatsApp in Pepper Cloud WhatsApp CRM.",
    },
    {
      question:
        "Can all members of my team communicate with customers through one WhatsApp number?",
      answer:
        "Yes, WhatsApp CRM enables your entire team to chat with leads and customers from a single WhatsApp number.",
    },
    {
      question: "How long does it take to set up WhatsApp for my business?",
      answer:
        "If you have all the prerequisites ready, you can start using WhatsApp through CRM within a few hours.",
    },
    {
      question: 
      "Does WhatsApp CRM support ticket management and escalation?",
      answer:
        "Absolutely. Incoming chats can be converted into support tickets automatically, assigned to the right agent, and escalated if SLA thresholds are at risk.",
    },
    {
      question:
        "Does Pepper Cloud charge for WhatsApp messages sent through the CRM?",
      answer:
        "No, Pepper Cloud doesn’t charge for the messages. However, you may incur charges from WhatsApp.",
    },
    {
      question:
        "What other channel integrations are available in the Pepper Cloud CRM system?",
      answer:
        "Pepper Cloud CRM is a multi-channel integrated platform that integrates with WhatsApp, Facebook Messenger, Instagram, Telegram, and others.",
    },
    {
      question: "Can I use the business grant to avail Pepper Cloud CRM?",
      answer:
        "Pepper Cloud CRM is an IMDA-approved digital solution, and you can use up to 50% business grant to avail it.",
    },
    {
      question: "Is Pepper Cloud CRM mobile-friendly?",
      answer: (
        <>
          Yes, you can download the Pepper Cloud CRM{" "}
          <a href="https://peppercloud.com/best-mobile-crm-system-app-ios-android/">
            mobile app
          </a>
          . It enables you to manage records and conversations while on the 
          go.
        </>
      ),
    },
  ];

  const experienceList = [
    {
      title: "One account, multiple agents",
      img: experienceImg1,
      alt: "AI WhatsApp CRM for Sales & Customer Support",
      desc: "Empower sales and support agents to handle customer inquiries seamlessly from any device using a single WhatsApp account.",
    },
    {
      title: "Built for SMEs",
      alt: "AI WhatsApp CRM for Sales & Customer Support",
      img: experienceImg2,
      desc: "Capture and convert leads, maintain client profiles, manage support tickets, and win sales conversations with best CRM for WhatsApp.",
    },
    {
      title: "Omnichannel CRM",
      alt: "AI WhatsApp CRM for Sales & Customer Support",
      img: experienceImg3,
      desc: "Unify every touchpoint, such as WhatsApp, email, and more, so your sales and support teams can deliver a consistent customer experience.",
    },
    {
      title: "24/7 Local support",
      alt: "AI WhatsApp CRM for Sales & Customer Support",
      img: experienceImg4,
      desc: "Get real-time assistance for your sales and service operations through chat, calls, or email, whenever your team needs it.",
    },
  ];
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollPosition(currentScrollY);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // setSubMenuOpen(false);
        // setIsVisible(false);
      } else {
        // setSubMenuOpen(false);
        // setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });

  // When the section is in view, set up a timer to auto change the active accordion every 5 seconds.
  useEffect(() => {
    let timer;
    if (inView) {
      timer = setInterval(() => {
        setActiveAccordian((prev) => (prev + 1) % experienceList.length);
      }, 5500);
    }
    // Clear the timer when the component unmounts or when inView changes.
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [inView, experienceList.length]);
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  React.useEffect(() => {
    const pcIframe = document.getElementById("pc-iframe");
    pcIframe.src = pcIframe.src + window.location.search;
    if (window.location.search)
      pcIframe.src = pcIframe.src + "&page_title=" + document.title;
    else pcIframe.src = pcIframe.src + "?page_title=" + document.title;
  }, []);

  if (
    typeof window !== "undefined" &&
    window.location.pathname === "/crm-with-whatsapp-integration/" &&
    window.location.search.includes("thankyou=true")
  ) {
    if (typeof window.gtag === "function") {
      window.gtag("event", "CRM_with_WhatsApp_Integration_HM", {});
    }
  }
  return (
    <main>
      <SEO
        noindex
        title={
          "Best AI WhatsApp CRM for Sales & Customer Support | AI CRM for SMEs"
        }
        pathname={"https://peppercloud.com/crm-with-whatsapp-integration/"}
        keywords="crm with whatsapp integration, ai powered crm, crm WhatsApp integration, WhatsApp CRM, CRM WhatsApp, WhatsApp CRM integration, WhatsApp broadcast, WhatsApp broadcast for business, crm system integration, whatsapp business template, whatsapp web integration, bulk messages through whatsapp, whatsapp business greeting message template, business grant singapore, singapore startup grants, sme grants singapore, crm singapore, crm system singapore"
        description={
          "Pepper Cloud AI CRM unifies WhatsApp sales and support in one platform. Qualify leads, run WhatsApp campaigns, auto-assign tickets, and accelerate growth with automation. The all-in-one WhatsApp CRM built for SMEs to scale faster, cut costs, and delight customers."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        // scripts={[`gtag('event', 'CRM_with_WhatsApp_Integration_HM', {});`]}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: [
                        "sales@peppercloud.com",
                        "support@peppercloud.com",
                     ],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "I’m an SME. How can WhatsApp CRM benefit us?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "WhatsApp CRM system can be an effective sales tool for SMEs. With WhatsApp CRM, you can provide personalised customer service, streamline your sales process, and track all customer interactions in one place. With features such as message templates, automated replies, chatbots, tags, etc., you can save time and focus on growing your business.",
                },
              },
              {
                "@type": "Question",
                name: "How does AI help in sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI in sales leverages artificial intelligence to optimise sales processes. With Pepper Cloud CRM generative AI - AssistAI, you can automate chatflows using AI chatbot, manage routine tasks (such as capturing leads, answering common queries, etc.) without any manual intervention, analyse customer data, personalise communication, and boost overall sales effectiveness.",
                },
              },
              {
                "@type": "Question",
                name: "How does AI help in customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI chatbots handle FAQs, auto-respond after hours, and suggest replies for agents. This reduces response time, cuts repetitive tasks, and ensures consistent service quality.",
                },
              },
              {
                "@type": "Question",
                name: "How can WhatsApp CRM improve my customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "WhatsApp CRM centralises all customer conversations in one place. It enables multi-agent access, automated ticket creation, SLA tracking, and AI-powered responses — so your team resolves issues faster and improves satisfaction.",
                },
              },
              {
                "@type": "Question",
                name: "Can I use my existing number for WhatsApp CRM integration?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can use your existing number for WhatsApp in Pepper Cloud WhatsApp CRM.",
                },
              },
              {
                "@type": "Question",
                name: "Can all members of my team communicate with customers through one WhatsApp number?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, WhatsApp CRM enables your entire team to chat with leads and customers from a single WhatsApp number.",
                },
              },
              {
                "@type": "Question",
                name: "How long does it take to set up WhatsApp for my business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "If you have all the prerequisites ready, you can start using WhatsApp through CRM within a few hours.",
                },
              },
              {
                "@type": "Question",
                name: "Does WhatsApp CRM support ticket management and escalation?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. Incoming chats can be converted into support tickets automatically, assigned to the right agent, and escalated if SLA thresholds are at risk.",
                },
              },
              {
                "@type": "Question",
                name: "Does Pepper Cloud charge for WhatsApp messages sent through the CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "No, Pepper Cloud doesn’t charge for the messages. However, you may incur charges from WhatsApp.",
                },
              },
              {
                "@type": "Question",
                name: "What other channel integrations are available in the Pepper Cloud CRM system?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is a multi-channel integrated platform that integrates with WhatsApp, Facebook Messenger, Instagram, Telegram, and others.",
                },
              },
              {
                "@type": "Question",
                name: "Can I use the business grant to avail Pepper Cloud CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is an IMDA-approved digital solution, and you can use up to 50% business grant to avail it.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM mobile-friendly?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can download the Pepper Cloud CRM mobile app. It enables you to manage records and conversations while on the go.",
                },
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: "AssistAI",
            description:
              "Harness the power of Pepper Cloud's AssistAI to simplify conversations, automate tasks, streamline workflows, and more. Save time, improve productivity, and make smarter sales decisions with the best AI CRM for your sales workflow.",
            thumbnailUrl: [
              "https://drive.google.com/file/d/11D38QAsWjwxtUae6YnwdP1Y__tusgmRF/view?usp=drive_link",
            ],
            uploadDate: "2024-12-02",
            contentUrl:
              "https://peppercloud.com/static/aiPageHeroSection-3907c41f7c08dfe21633f203852eebe2.mp4",
            publisher: {
              "@type": "Organization",
              name: "Pepper Cloud",
              logo: {
                "@type": "ImageObject",
                url: "https://d4.alternativeto.net/TylnV9uYJt3KRkoH7m9Qbm-T2kdjqV4X3JgKsTxbTUs/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy9wZXBwZXItY2xvdWQtY3JtXzI0MzM4NS5wbmc.png",
                width: "",
                height: "",
              },
            },
            duration: "PT1M12S",
          },
        ]}
      />
      <div className={classes.headerContainer}>
        <div
          className={clsx(
            classes.headerContainerInner,
            scrollPosition > 200 && "glassEffect",
          )}
        >
          <div className={classes.leftNavigation}>
            <Link to="/">
              <img
                src={companyLogo}
                alt="AI WhatsApp CRM for Sales & Customer Support"
              />
            </Link>
          </div>
          <div className={classes.rightNavigation}>
            <p className="font-20 font-white font-wix-semibold">
              Book a free demo
            </p>
            <a href="tel:+6597510475" onClick={conversionEventOnCall}>
              <img
                src={callImg}
                alt="AI WhatsApp CRM for Sales & Customer Support"
              />
              <p className="font-20 font-wix-medium font-white">
                +65 97510475
                </p>
            </a>
          </div>
        </div>
      </div>
      <section className={classes.whatsappSectionContainer}>
        <div className="container">
          <div className={classes.whatsappContainer}>
            <div className={classes.whatsappContainerLeft}>
              <motion.h1
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-64 color-black1"
              >
                Drive sales and support with{" "}
                <span className="highlighterText">
                           AI + WhatsApp CRM{" "}
                        </span>
              </motion.h1>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-20 color-black2"
              >
                Accelerate end-to-end customer journey with AI-powered WhatsApp
                CRM. From first lead to final resolution, connect instantly,
                automate effortlessly, and transform every conversation into an
                opportunity.
              </motion.p>
              <div className={classes.tagsContainer}>
                <div className={classes.tag}>
                  <img
                    src={greenCheckIcon}
                    alt="AI WhatsApp CRM for Sales & Customer Support"
                  />
                  <p className="font-16 font-black2 font-wix-regular">
                    AI-powered automation
                  </p>
                </div>
                <div className={classes.tag}>
                  <img
                    src={greenCheckIcon}
                    alt="AI WhatsApp CRM for Sales & Customer Support"
                  />
                  <p className="font-16 font-black2 font-wix-regular">
                    Up to 50% business grant
                  </p>
                </div>
                <div className={classes.tag}>
                  <img
                    src={greenCheckIcon}
                    alt="AI WhatsApp CRM for Sales & Customer Support"
                  />
                  <p className="font-16 font-black2 font-wix-regular">
                    24/7 Local support
                  </p>
                </div>
                <div className={classes.tag}>
                  <img
                    src={greenCheckIcon}
                    alt="AI WhatsApp CRM for Sales & Customer Support"
                  />
                  <p className="font-16 font-black2 font-wix-regular">
                    Built for SMEs
                  </p>
                </div>
              </div>
              <div className={classes.rewards}>
                <img
                  src={whatsappBusinessPartner}
                  alt="WhatsApp Business Partner"
                />
                <div className="border" />
                <img src={metaBusinessPartner} alt="Meta Business Partner" />
                <div className="border" />
                <img
                  src={trailBlazerBusinessPartner}
                  alt="AI WhatsApp CRM for Sales & Customer Support"
                />
              </div>
            </div>
            <div className={classes.whatsappContainerRight}>
              <div className={classes.formHeader}>
                <p className="font-24 font-white font-wix-semibold">
                  Avail up to <span>50%</span> business grant
                </p>
              </div>
              <div className={classes.formContainer}>
                <iframe
                  width={"100%"}
                  height={"470px"}
                  style={{ border: "none" }}
                  id="pc-iframe"
                  src="https://app.peppercloud.com/form/40d71e54-e07a-43dd-a94c-f3ae429540b6/embed"
                />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.bannerImgSection}>
          <img
            src={bannerImgNew}
            className={classes.mobImg}
            alt="AI WhatsApp CRM for Sales & Customer Support"
          />
          <img
            src={bannerImgNew}
            className={classes.webImg}
            alt="AI WhatsApp CRM for Sales & Customer Support"
          />
        </div>
      </section>
      <section className={classes.bannerSection}>
        <LottieIcon
          className={classes.backgroundAnimation}
          animationData={wpAdPageAnimation}
          autoplay
          loop
          play
          hover={false}
        />
        <LottieIcon
          className={classes.backgroundAnimationMobile}
          animationData={wpAdPageAnimationMobile}
          autoplay
          loop
          play
          hover={false}
        />
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              <img src={whatsAppFeatureIcon} alt="WhatsApp CRM integration" />{" "}
              WhatsApp CRM suite with 100+ powerful features
            </motion.h2>
          </div>
        </div>
      </section>
      <section className={classes.trustedSection}>
        <TruestedSection />
      </section>
      <section className={classes.moreFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 color-black1"
            >
              One platform for unified sales and support
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-18 color-black1"
            >
              Close deals quicker, solve issues smarter, and grow stronger with
              Pepper Cloud AI-powered WhatsApp CRM.
            </motion.p>
          </div>
          <div className="body">
            {featureList.map((feature) => (
              <div
                className={classes.featureContainer}
                style={{ backgroundImage: `url(${feature.background})` }}
              >
                <LazyImage
                  source={feature.icon}
                  alt={"AI WhatsApp CRM for Sales & Customer Support"}
                  className={classes.featureIcon}
                />
                <p className="font-wix-semibold font-24 font-white">
                  {feature.heading}
                </p>
                <p className="font-wix-mediu font-18 font-white">
                  {feature.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.broadcastContainer}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 text-black1"
            >
              Transform chaos into clarity with all-in-one WhatsApp CRM
            </motion.h2>
          </div>
        </div>
        <Swiper
          slidesPerView={1.1}
          centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={false}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          // freeMode={true}
          className={classes.broadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1.1,
              slidesPerGroup: 1,
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 1.1,
              centeredSlides: true,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {broadcastList.map((point, index) => (
            <SwiperSlide
              className={classes.broadcastBox}
              style={{ background: point.background }}
            >
              <div className={classes.broadcastLeftContainer}>
                <p className="font-40 font-wix-medium font-white">
                  {point.heading}
                </p>
                <div className={classes.pointers}>
                  {point.points.map((content) => (
                    <div className={classes.cardPointer}>
                      <LazyImage
                        source={whiteCheckCircle}
                        className={classes.pointerImg}
                        alt={"AI WhatsApp CRM for Sales & Customer Support"}
                      />
                      <p className="font-wix-regular font-18 font-white">
                        {content}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              <div className={classes.broadcastRightContainer}>
                <img
                  src={point.img}
                  alt={"AI WhatsApp CRM for Sales & Customer Support"}
                  className={classes.broadcastImg}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.aIPowered}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Get immediate results with AI-powered WhatsApp CRM
            </motion.h2>
          </div>
          <div className={classes.statsContainer}>
            {statsBoxContent.map((stat, index) => (
              <motion.div
                whileInView={{ opacity: [0, 1], y: [50, 0] }}
                transition={{ duration: 1, delay: index * 0.1 }}
                className={classes.statsBox}
              >
                <p className={clsx(classes.statsFont, "font-wix-medium")}>
                  {stat.number}{" "}
                  <span className="font-56 font-wix-medium">%</span>
                </p>
                <div className="border" />
                {/* <div className={classes.statsBoxHeader}>
                 
                </div> */}
                <div className={classes.statsBoxBody}>
                  <p className="font-18 color-purple3 font-wix-semibold">
                    {stat.heading}
                  </p>
                  <p className="font-16 color-purple3 font-wix-regular">
                    {stat.content}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
          <div className={classes.belowText}>
            <p className="font-12 font-wix-regular">
              * Statistics from multiple sources
            </p>
          </div>
        </div>
      </section>
      <section className={classes.experienceContainer} ref={ref}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 text-black1"
            >
              Experience enterprise power with SME simplicity
            </motion.h2>
          </div>
          <div className={classes.experienceInnerContainer}>
            <div className={classes.experienceContainerLeft}>
              {experienceList.map((faq, index) => (
                <motion.div
                  whileInView={{ opacity: [0, 1], y: [50, 0] }}
                  transition={{ duration: 1, delay: index * 0.01 }}
                  className={clsx(
                    classes.faqBox,
                    index === activeAccordian && "active"
                  )}
                  onClick={() => setActiveAccordian(index)}
                >
                  <div className={classes.faqHeader}>
                    <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                    <img
                      src={downArrow}
                      alt="AI WhatsApp CRM for Sales & Customer Support"
                      className={clsx(
                        classes.downArrow,
                        index === activeAccordian && "active"
                      )}
                    />
                  </div>
                  <Collapse
                    className={classes.body}
                    in={activeAccordian === index}
                  >
                    <p className="font-18 font-wix-regular color-black2">
                      {faq.desc}
                    </p>
                    <motion.img
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      src={faq.img}
                      alt={faq.alt}
                    />
                  </Collapse>
                </motion.div>
              ))}
            </div>
            <div className={classes.experienceContainerRight}>
              {experienceList.map(
                (experience, index) =>
                  index === activeAccordian && (
                    <motion.img
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      src={experience.img}
                      alt={experience.alt}
                    />
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.supportSystem}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              AI+WhatsApp CRM: Built to support all industries
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                Beauty salons
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Food delivery
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Travel agencies
              </div>
            </div>
          </div>
          {supportList.map(
            (point, index) =>
              activeRealWorld === index && (
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.supportBox}
                  // style={{ background: point.background }}
                >
                  <div className={classes.broadcastLeftContainer}>
                    <p className="font-40 font-wix-regular font-white">
                      {point.heading}
                    </p>
                    <p className="font-18 font-wix-regular font-white">
                      {point.desc}
                    </p>
                    <div className={classes.pointers}>
                      {point.point.map((content) => (
                        <div className={classes.cardPointer}>
                          <LazyImage
                            source={whiteCheckCircle}
                            className={classes.pointerImg}
                            alt={"AI WhatsApp CRM for Sales & Customer Support"}
                          />
                          <p className="font-wix-regular font-18 font-white">
                            {content}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className={classes.broadcastRightContainer}>
                    <LazyImage
                      source={point.img}
                      alt={"AI WhatsApp CRM for Sales & Customer Support"}
                      className={classes.broadcastImg}
                    />
                  </div>
                </motion.div>
              )
          )}
        </div>
      </section>
      <section className={classes.smeSection}>
        <div className="container">
         {/* -----IMDA Lockup-------  */}
         <div className={classes.imdaStyle}><IMDALockup/></div>
          <div className="centerContainer">
            <motion.h2 className="font-24 font-wix-medium color-black1 text-center">
              Brands worldwide trust our AI WhatsApp CRM to streamline sales and
              support
            </motion.h2>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={2000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          heading={"Frequently asked questions"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="font-wix-medium font-56 font-white"
            >
              Boost your sales and support with AI-powered WhatsApp CRM
            </motion.h2>
            <button
              className="primaryButton font-20 font-wix-medium font-white"
              onClick={() => scrollToTop()}
            >
              Get started
            </button>
          </div>
        </div>
      </section>
      <div className={classes.pageFooter}>
        <div className="container">
          <p className="font-14 font-wix-regular">
            © Pepper Cloud - Best AI WhatsApp CRM Software for Sales and Support {' '}
            {new Date().getFullYear()}
          </p>
          {/* <Link className="font-14 font-wix-regular">Site map</Link> */}
        </div>
      </div>
    </main>
  );
};

export default WpAdLandingPage;
